import React from 'react';
import PageBreadcrumb from '../components/PageBreadcrumb';

const faqs = [
    { q: 'How can I donate?', a: 'Go to the Donate page, choose campaign or general support, and complete secure checkout.' },
    { q: 'Can I volunteer remotely?', a: 'Yes. You can support with mentorship, content, design, and digital operations.' },
    { q: 'Do you publish project updates?', a: 'Yes, updates are shared through News, Projects, and periodic popup announcements.' },
    { q: 'How do I partner with YAP?', a: 'Use our Contact page with your organization details and collaboration scope.' },
];

const Faq = () => (
    <div className="bg-slate-50">
        <PageBreadcrumb
            title="Frequently Asked Questions"
            description="Quick answers about YAP programs, donations, and engagement."
            items={[{ label: 'FAQ' }]}
        />
        <section className="mx-auto max-w-5xl space-y-4 px-4 py-14">
            {faqs.map((item) => (
                <details key={item.q} className="rounded-xl border border-slate-200 bg-white p-5 shadow-sm open:shadow-md">
                    <summary className="cursor-pointer text-lg font-semibold text-slate-800">{item.q}</summary>
                    <p className="mt-3 text-slate-600">{item.a}</p>
                </details>
            ))}
        </section>
    </div>
);

export default Faq;
